import { eqProps, find } from 'ramda';
import { metrics } from 'system/libs/metrics';
import notify from 'system/mediators/NotifyManager';

import s3, { PUBLIC_GRANT } from '../../s3';

export const BUCKET_OBJECTS_ACL_CANCEL = 'BUCKET_OBJECTS_ACL_CANCEL';
export function actionAclCancel() {
    return {
        type: BUCKET_OBJECTS_ACL_CANCEL,
    };
}

export const BUCKET_OBJECTS_ACL_FETCH_REQUEST =
    'BUCKET_OBJECTS_ACL_FETCH_REQUEST';
export function actionAclFetchRequest({ Key }) {
    return {
        type: BUCKET_OBJECTS_ACL_FETCH_REQUEST,
        data: { Key },
    };
}

export const BUCKET_OBJECTS_ACL_FETCH_SUCCESS =
    'BUCKET_OBJECTS_ACL_FETCH_SUCCESS';
export function actionAclFetchSuccess({ type }) {
    return {
        type: BUCKET_OBJECTS_ACL_FETCH_SUCCESS,
        data: { type },
    };
}

export const BUCKET_OBJECTS_ACL_FETCH_FAILURE =
    'BUCKET_OBJECTS_ACL_FETCH_FAILURE';
export function actionAclFetchFailure() {
    return {
        type: BUCKET_OBJECTS_ACL_FETCH_FAILURE,
    };
}

export const BUCKET_OBJECTS_ACL_CHANGE_REQUEST =
    'BUCKET_OBJECTS_ACL_CHANGE_REQUEST';
function actionAclChangeRequest() {
    return {
        type: BUCKET_OBJECTS_ACL_CHANGE_REQUEST,
    };
}

export const BUCKET_OBJECTS_ACL_CHANGE_SUCCESS =
    'BUCKET_OBJECTS_ACL_CHANGE_SUCCESS';
function actionAclChangeReceive({ type }) {
    return {
        type: BUCKET_OBJECTS_ACL_CHANGE_SUCCESS,
        data: { type },
    };
}

export const BUCKET_OBJECTS_ACL_CHANGE_FAILURE =
    'BUCKET_OBJECTS_ACL_CHANGE_FAILURE';
function actionAclChangeFailure() {
    return {
        type: BUCKET_OBJECTS_ACL_CHANGE_FAILURE,
    };
}

export function asyncActionAclFetch({ Bucket, Key }) {
    return async function(dispatch) {
        try {
            dispatch(actionAclFetchRequest({ Key }));

            const {
                data: { Grants },
            } = await s3('getObjectAcl', { Bucket, Key });
            const type = find(eqProps('Grantee', PUBLIC_GRANT), Grants)
                ? 'public-read'
                : 'private';

            dispatch(actionAclFetchSuccess({ type }));
        } catch (reason) {
            dispatch(actionAclFetchFailure());
            notify.error('Не удалось загрузить ACL');
        }
    };
}

export function asyncActionAclChange({ Bucket, Key, ACL }) {
    return async function(dispatch) {
        dispatch(actionAclChangeRequest());

        try {
            await s3('putObjectAcl', { Bucket, Key, ACL });

            dispatch(actionAclChangeReceive({ type: ACL }));
            metrics.send({
                action: 'AclFileChangeSuccess',
            });
        } catch (reason) {
            dispatch(actionAclChangeFailure());
            notify.error('Не удалось изменить ACL');
            metrics.send({
                action: 'AclFileChangeError',
            });
        }
    };
}
